import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const scanDrinkCoupon = (
    venueId,
    userCode,
    adminCode,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        userCode: userCode,
        adminCode: adminCode
    };
    fetchPost(
        uri + "/venue/" + venueId + "/drink/coupon",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};